import { connect } from "react-redux";

import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withFormActionHandlerExecution } from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { ActionContainerProps } from "../Common/ActionContainerProps";
import { withEvaluators } from "../../withEvaluators";

import { DropdownButtonAction } from "./DropdownButtonAction";

const mapStateToProps = (state: FullFormState, ownProps: ActionContainerProps) => {
    const { bindingPath, disabled, disabled2, visible, viewModelSelect, processEvaluableProp } = ownProps;

    let controlModel;
    if (bindingPath) {
        controlModel = viewModelSelect.controlModel(state, bindingPath);
    }

    return {
        disabled: processEvaluableProp(state, disabled2) || (controlModel?.disabled ?? disabled),
        visible: processEvaluableProp(state, visible),
    };
};

const mapDispatchToProps = (_: CandyDispatch, ownProps: ActionContainerProps) => ({
    onClick: async (event: unknown) => {
        // Эта штука нужна ибо ниже выставляется __MENU_ITEM__ = true
        // react-ui при этом кинет нам сюда onClick и корректно закроет DropDownMenu
        ownProps.onClick?.(event);
        if (ownProps.onActionClick != undefined) {
            await ownProps.executeFormActionHandler(ownProps.onActionClick);
        }
    },
});

export const DropdownButtonActionContainer = withResolvePaths(
    withFormActionHandlerExecution(
        withViewModelSelect(withEvaluators(connect(mapStateToProps, mapDispatchToProps)(DropdownButtonAction)))
    )
);

// @ts-ignore
DropdownButtonActionContainer.__MENU_ITEM__ = true;

// @ts-ignore эта пропертя заставляет react-ui склонировать всех детей ниже
//  и передать им в props свойства onMouseEnter/onMouseLeave что позволяет управлять ховером
DropdownButtonActionContainer.__KONTUR_REACT_UI__ = "MenuItem";
